var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('User'),(_vm.showShortcuts())?_c('Shortcuts'):_vm._e(),(_vm.showHistory())?_c('History'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }